export enum NewSignupPageSectionEnum {
  POST_SIGN_UP_PAGE = 'postSignUpPage',
  SELECT_ORGANISATION_PAGE = 'selectOrganisationPage',
  CREATE_ORGANISATION = 'createOrganisation',
  COMPLETED = 'COMPLETED',
}
